export var UPLOAD_OPTIONS_COMP = Symbol.for("rpldy_component");